type ActivityReason = 'recording' | 'uploading';

type Listener = (isProtected: boolean) => void;

class SessionActivityController {
  private reasonCounters: Record<ActivityReason, number> = {
    recording: 0,
    uploading: 0
  };

  private listeners = new Set<Listener>();

  private emit() {
    const isProtected = this.isProtected();
    this.listeners.forEach((listener) => listener(isProtected));
  }

  private updateReason(reason: ActivityReason, isActive: boolean) {
    const currentValue = this.reasonCounters[reason];
    const nextValue = isActive ? currentValue + 1 : Math.max(0, currentValue - 1);

    if (currentValue === nextValue) {
      return;
    }

    this.reasonCounters[reason] = nextValue;
    this.emit();
  }

  setRecordingActive(isActive: boolean) {
    this.updateReason('recording', isActive);
  }

  setUploadActive(isActive: boolean) {
    this.updateReason('uploading', isActive);
  }

  isProtected() {
    return this.reasonCounters.recording > 0 || this.reasonCounters.uploading > 0;
  }

  reset() {
    this.reasonCounters = { recording: 0, uploading: 0 };
    this.emit();
  }

  subscribe(listener: Listener) {
    this.listeners.add(listener);
    listener(this.isProtected());

    return () => {
      this.listeners.delete(listener);
    };
  }
}

export const sessionActivity = new SessionActivityController();